// Mock data for Agora marketplace

export const categories = [
  { id: 'electronics', name: 'Electronics', icon: 'Laptop' },
  { id: 'fashion', name: 'Fashion', icon: 'Shirt' },
  { id: 'furniture', name: 'Furniture', icon: 'Armchair' },
  { id: 'books', name: 'Books', icon: 'BookOpen' },
  { id: 'toys', name: 'Toys & Games', icon: 'Gamepad2' },
  { id: 'sports', name: 'Sports', icon: 'Dumbbell' },
  { id: 'home', name: 'Home & Living', icon: 'Home' },
  { id: 'beauty', name: 'Beauty', icon: 'Sparkles' },
];

export const listings = [
  {
    id: '1',
    title: 'iPhone 14 Pro Max 256GB',
    price: 1299,
    condition: 'Like New',
    category: 'electronics',
    location: 'Singapore',
    image: 'https://images.unsplash.com/photo-1498049794561-7780e7231661?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxlbGVjdHJvbmljc3xlbnwwfHx8fDE3NjQxNzE1OTJ8MA&ixlib=rb-4.1.0&q=85',
    description: 'Barely used iPhone 14 Pro Max in excellent condition. Comes with original box and accessories.',
    sellerId: 'user1',
    sellerName: 'Sarah Chen',
    sellerAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah',
    sellerRating: 4.8,
    listedAt: '2024-01-15',
    views: 245,
    likes: 32,
  },
  {
    id: '2',
    title: 'Vintage Leather Jacket',
    price: 89,
    condition: 'Used',
    category: 'fashion',
    location: 'Singapore',
    image: 'https://images.unsplash.com/photo-1483985988355-763728e1935b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxmYXNoaW9ufGVufDB8fHx8MTc2NDE2OTI2NHww&ixlib=rb-4.1.0&q=85',
    description: 'Authentic vintage leather jacket from the 90s. Size M, perfect condition.',
    sellerId: 'user2',
    sellerName: 'Mike Tan',
    sellerAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Mike',
    sellerRating: 4.5,
    listedAt: '2024-01-14',
    views: 156,
    likes: 18,
  },
  {
    id: '3',
    title: 'Modern Accent Chair',
    price: 250,
    condition: 'New',
    category: 'furniture',
    location: 'Singapore',
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxmdXJuaXR1cmV8ZW58MHx8fHwxNzY0MTcxNjAxfDA&ixlib=rb-4.1.0&q=85',
    description: 'Brand new modern accent chair. Yellow velvet upholstery, gold legs. Never used.',
    sellerId: 'user3',
    sellerName: 'Emma Wong',
    sellerAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Emma',
    sellerRating: 5.0,
    listedAt: '2024-01-13',
    views: 189,
    likes: 45,
  },
  {
    id: '4',
    title: 'Harry Potter Complete Collection',
    price: 45,
    condition: 'Used',
    category: 'books',
    location: 'Singapore',
    image: 'https://images.unsplash.com/photo-1610116306796-6fea9f4fae38?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxib29rc3xlbnwwfHx8fDE3NjQxNzE2MDd8MA&ixlib=rb-4.1.0&q=85',
    description: 'Complete set of Harry Potter books in good condition. Some wear on covers.',
    sellerId: 'user4',
    sellerName: 'David Lim',
    sellerAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=David',
    sellerRating: 4.7,
    listedAt: '2024-01-12',
    views: 134,
    likes: 22,
  },
  {
    id: '5',
    title: 'Wireless Gaming Headset',
    price: 120,
    condition: 'Like New',
    category: 'electronics',
    location: 'Singapore',
    image: 'https://images.unsplash.com/photo-1550009158-9ebf69173e03?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxlbGVjdHJvbmljc3xlbnwwfHx8fDE3NjQxNzE1OTJ8MA&ixlib=rb-4.1.0&q=85',
    description: 'Premium wireless gaming headset with noise cancellation. Used only twice.',
    sellerId: 'user1',
    sellerName: 'Sarah Chen',
    sellerAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah',
    sellerRating: 4.8,
    listedAt: '2024-01-11',
    views: 298,
    likes: 56,
  },
  {
    id: '6',
    title: 'Wooden Train Set',
    price: 35,
    condition: 'Used',
    category: 'toys',
    location: 'Singapore',
    image: 'https://images.unsplash.com/photo-1596461404969-9ae70f2830c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHx0b3lzfGVufDB8fHx8MTc2NDE3MTYxMnww&ixlib=rb-4.1.0&q=85',
    description: 'Classic wooden train set with tracks and accessories. Great for kids.',
    sellerId: 'user5',
    sellerName: 'Jessica Ng',
    sellerAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Jessica',
    sellerRating: 4.9,
    listedAt: '2024-01-10',
    views: 112,
    likes: 15,
  },
  {
    id: '7',
    title: 'Designer Handbag',
    price: 450,
    condition: 'Like New',
    category: 'fashion',
    location: 'Singapore',
    image: 'https://images.unsplash.com/photo-1558769132-cb1aea458c5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHw0fHxmYXNoaW9ufGVufDB8fHx8MTc2NDE2OTI2NHww&ixlib=rb-4.1.0&q=85',
    description: 'Authentic designer handbag, barely used. Comes with authenticity card.',
    sellerId: 'user2',
    sellerName: 'Mike Tan',
    sellerAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Mike',
    sellerRating: 4.5,
    listedAt: '2024-01-09',
    views: 387,
    likes: 78,
  },
  {
    id: '8',
    title: 'Comfortable Green Sofa',
    price: 380,
    condition: 'Used',
    category: 'furniture',
    location: 'Singapore',
    image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxmdXJuaXR1cmV8ZW58MHx8fHwxNzY0MTcxNjAxfDA&ixlib=rb-4.1.0&q=85',
    description: '3-seater sofa in excellent condition. Comfortable and stylish.',
    sellerId: 'user3',
    sellerName: 'Emma Wong',
    sellerAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Emma',
    sellerRating: 5.0,
    listedAt: '2024-01-08',
    views: 223,
    likes: 41,
  },
  {
    id: '9',
    title: 'Camera Equipment Bundle',
    price: 890,
    condition: 'Like New',
    category: 'electronics',
    location: 'Singapore',
    image: 'https://images.pexels.com/photos/356056/pexels-photo-356056.jpeg',
    description: 'Professional camera with lenses and accessories. Perfect for photography enthusiasts.',
    sellerId: 'user4',
    sellerName: 'David Lim',
    sellerAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=David',
    sellerRating: 4.7,
    listedAt: '2024-01-07',
    views: 445,
    likes: 89,
  },
  {
    id: '10',
    title: 'Lego Building Blocks Set',
    price: 68,
    condition: 'New',
    category: 'toys',
    location: 'Singapore',
    image: 'https://images.unsplash.com/photo-1587654780291-39c9404d746b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHx0b3lzfGVufDB8fHx8MTc2NDE3MTYxMnww&ixlib=rb-4.1.0&q=85',
    description: 'Brand new sealed Lego set. Great gift for kids and collectors.',
    sellerId: 'user5',
    sellerName: 'Jessica Ng',
    sellerAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Jessica',
    sellerRating: 4.9,
    listedAt: '2024-01-06',
    views: 178,
    likes: 34,
  },
  {
    id: '11',
    title: 'Classic Literature Collection',
    price: 55,
    condition: 'Used',
    category: 'books',
    location: 'Singapore',
    image: 'https://images.unsplash.com/photo-1495446815901-a7297e633e8d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxib29rc3xlbnwwfHx8fDE3NjQxNzE2MDd8MA&ixlib=rb-4.1.0&q=85',
    description: 'Collection of classic literature books. Well-maintained.',
    sellerId: 'user1',
    sellerName: 'Sarah Chen',
    sellerAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah',
    sellerRating: 4.8,
    listedAt: '2024-01-05',
    views: 167,
    likes: 28,
  },
  {
    id: '12',
    title: 'Casual Sneakers',
    price: 75,
    condition: 'Like New',
    category: 'fashion',
    location: 'Singapore',
    image: 'https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg',
    description: 'Comfortable casual sneakers, worn only a few times. Size 9.',
    sellerId: 'user2',
    sellerName: 'Mike Tan',
    sellerAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Mike',
    sellerRating: 4.5,
    listedAt: '2024-01-04',
    views: 201,
    likes: 37,
  },
];

export const messages = [
  {
    id: '1',
    senderId: 'user2',
    senderName: 'Mike Tan',
    senderAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Mike',
    listingId: '1',
    listingTitle: 'iPhone 14 Pro Max 256GB',
    lastMessage: 'Is this still available?',
    timestamp: '2024-01-15T10:30:00',
    unread: true,
  },
  {
    id: '2',
    senderId: 'user3',
    senderName: 'Emma Wong',
    senderAvatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Emma',
    listingId: '5',
    listingTitle: 'Wireless Gaming Headset',
    lastMessage: 'Can you do $100?',
    timestamp: '2024-01-14T15:20:00',
    unread: false,
  },
];

export const conversations = {
  '1': [
    {
      id: 'msg1',
      senderId: 'user2',
      text: 'Hi, is this still available?',
      timestamp: '2024-01-15T10:30:00',
    },
    {
      id: 'msg2',
      senderId: 'currentUser',
      text: 'Yes, it is! Are you interested?',
      timestamp: '2024-01-15T10:35:00',
    },
    {
      id: 'msg3',
      senderId: 'user2',
      text: 'Can I view it this weekend?',
      timestamp: '2024-01-15T10:40:00',
    },
  ],
  '2': [
    {
      id: 'msg4',
      senderId: 'user3',
      text: 'Can you do $100?',
      timestamp: '2024-01-14T15:20:00',
    },
    {
      id: 'msg5',
      senderId: 'currentUser',
      text: 'Sorry, $120 is the lowest I can go.',
      timestamp: '2024-01-14T15:25:00',
    },
  ],
};

export const currentUser = {
  id: 'currentUser',
  name: 'You',
  email: 'you@example.com',
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=You',
  rating: 4.9,
  memberSince: '2023-06-15',
  listings: ['1', '5'],
  favorites: ['3', '7', '9'],
};
